import axios, { AxiosResponse } from 'axios';

import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';
import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

import { ETypPrevodu } from './uePozadavky';

export enum IStavOvereni {
    VLASTNIK = 'VLASTNIK',
    NENALEZENO = 'NENALEZENO', // účet nenalezen službou dl302
    OVERENO = 'OVERENO', // účet nalezen službou dl302 a je typu 21/35/11
    KONTROLA = 'KONTROLA', // kontrola probíhá, účet typu 31
    UCNENALEZEN = 'UCNENALEZEN' // kontrola probíhá - účet zatím nenalezen (služba F24 zatím nenalezla osobu)
}

export interface IZalozeniPostId {
    stav: string;
    stavovereni: IStavOvereni;
    sankce: boolean;
}

export interface IZalozeniPost {
    id: number;
    stav?: string;
}

interface IDataZalozeniPOST {
    isin: string;
    datum: string;
    typ: ETypPozadavku | string;
    cenacp: number;
}
interface IDataZalozeniDLT {
    isin: string;
    datum: string;
    typprevodu: ETypPrevodu;
    datuhr: string;
    cenacp: string;
    mena: string;
    bankucet: string;
    minpoccp: string;
    typ: ETypPozadavku | string;
}

export interface IDataZalozeniPOSTid {
    idpolozky: number;
    pocetcp: number;
    ucet: string;
    idnabyvatele: string;
    koducastnika: string;
    cislozastavnismlouvy: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce: ETypTransakce;
    ppn?: boolean;
    idvlastnika: string;
    prijmeni: string;
    jmeno: string;
}

/* Založení požadavku */
export const ueZalozeniPost = (data: IDataZalozeniPOST) => {
    return axios({
        method: 'POST',
        url: '/UE/zalozeni',
        data: data
    }).then((resp: AxiosResponse<IZalozeniPost>) => resp.data);
};

/* Založení požadavku */
export const ueZalozeniDLTPost = (data: IDataZalozeniDLT, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: '/UED/zalozeni',
        data: data
    }).then((resp: AxiosResponse<IZalozeniPost>) => resp.data);
};

/* Založení nebo update položky požadavku (při ručním zadávání po jedné položce) */
export const ueZalozeniPostId = (id: number, data: IDataZalozeniPOSTid) => {
    return axios({
        method: 'POST',
        url: `/UE/${id}/zalozeni`,
        params: {
            id: id
        },
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};

export interface IDataZalozeniPozadavek {
    pocetcp: number;
    ucet: string;
    cislozastavnismlouvy: string;
    id?: number;
}

/* Založení nebo update položky požadavku (při ručním zadávání po jedné položce) */
export const ueZalozeniPozadavekDLT = (id: number, data: IDataZalozeniPozadavek, type: 'PUT' | 'POST') => {
    return axios({
        method: type,
        url: `/UED/${id}/zalozeni`,
        data: data
    }).then((resp: AxiosResponse<IZalozeniPostId>) => resp.data);
};
